'use client'

import { HOUSE_LIST_SHOW_MAP_KEY } from '@config'
import useProgressRouter from '@hooks/useProgressRouter'
import IconList from '@icon/house/list-view.svg'
import IconMap from '@icon/map.svg'
import { searchResultDataLayer } from '@plugin/google/gtm/modules/houseList'
import { isEqual } from 'lodash-es'
import { useCallback } from 'react'
import { useBoolean, useLocalStorage } from 'react-use'
import { getFilterRouter } from '../../search/filter/base'

export default function ToggleMap({
  state,
  showMap = false,
}) {
  const [visible, toggleVisible] = useBoolean(showMap)
  const { replaceRouter } = useProgressRouter()
  const [, setShowMapLocal] = useLocalStorage(HOUSE_LIST_SHOW_MAP_KEY, false)
  const changeHandle = useCallback(val => {
    searchResultDataLayer.toggleMap(val)
    toggleVisible()
    setShowMapLocal(val)
    const { slug } = state
    const [url, newSlug] = getFilterRouter(state)(houseRoute => {
      houseRoute.changeMapVisible(val)
    })

    if (!isEqual(slug, newSlug)) {
      replaceRouter(url)
    }
  }, [state, toggleVisible, replaceRouter, setShowMapLocal])

  return (
    <button
      type='button'
      className='cursor-pointer text-base flex items-center gap-x-6 border border-transparent text-primary sm:h-36 sm:px-10 rounded-xl hover:bg-primary-light'
      onClick={() => changeHandle(!visible)}
    >
      {
        visible
          ? (
            <>
              <IconList className='w-13 h-13 md:w-18 md:h-18 mr-6 fill-primary'></IconList>
              List
            </>
          )
          : (
            <>
              <IconMap className='w-12 h-12 md:w-18 md:h-18 mr-6 fill-primary'></IconMap>
              Map
            </>
          )
      }
    </button>
  )
}